import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";
import { H3Modal, H3Signature, H3Button } from "h3-mobile-vue";
import { H3Field } from "h3-mobile-vue";
import ControlBack from "@cloudpivot/form/src/common/directives/control-back";
let Signatrue = class Signatrue extends Vue {
    constructor() {
        super(...arguments);
        this.isFocus = false;
        this.signatrueHeight = 0;
        this.signatrueWidth = 0;
        this.isRest = true;
        this.img = "";
        this.signature = {};
    }
    mounted() {
        this.img = this.value;
        this.signature = this.$refs.signature;
    }
    show() {
        this.isFocus = true;
    }
    close() {
        this.isFocus = false;
    }
    showSignatrue() {
        if (this.readonly)
            return;
        this.isFocus ? this.close() : this.show();
        this.$nextTick(() => {
            const content = this.$refs.signatruewrap;
            this.signatrueHeight = content.offsetHeight;
            this.signatrueWidth = content.offsetWidth;
        });
    }
    back() {
        this.close();
    }
    reset() {
        this.signature.clear();
        this.isRest = true;
    }
    onBegin() {
        this.isRest = false;
    }
    ok() {
        this.signature.saveAsPng();
    }
    saveAsPng(data) {
        // debugger
        this.img = data;
        this.close();
        this.reset();
        this.$emit("change", this.img);
    }
    deleteImg() {
        if (this.readonly)
            return;
        this.img = "";
        this.isRest = false;
        this.$emit("change", this.img);
    }
    onValueChange(val) {
        if (val) {
            this.img = val;
        }
    }
};
tslib_1.__decorate([
    Model("change")
], Signatrue.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], Signatrue.prototype, "readonly", void 0);
tslib_1.__decorate([
    Prop({
        default: "手写签名",
    })
], Signatrue.prototype, "title", void 0);
tslib_1.__decorate([
    Prop({
        default: false,
    })
], Signatrue.prototype, "required", void 0);
tslib_1.__decorate([
    Prop({
        default: () => ({}),
    })
], Signatrue.prototype, "labelStyle", void 0);
tslib_1.__decorate([
    Prop({
        default: () => ({}),
    })
], Signatrue.prototype, "tip", void 0);
tslib_1.__decorate([
    Watch("value")
], Signatrue.prototype, "onValueChange", null);
Signatrue = tslib_1.__decorate([
    Component({
        name: "signatrue",
        components: {
            H3Modal,
            H3Signature,
            H3Button,
            H3Field,
        },
        directives: {
            ControlBack,
        },
    })
], Signatrue);
export default Signatrue;
